module.exports = __webpack_public_path__ + "img/SceneGame.aeb1f100.png";